export default __webpack_public_path__ + "static/media/img13.cb1f3248.png";